/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { run1  } from './Multiview';

run1(document.getElementById('viewer'));
